import React from 'react'
import { connect } from 'react-redux'
// import Loading from '../Shared/Loading'
import LoadingBar from '../Shared/LoadingBar'
import { history } from '../../_helpers'
import LoadingCircle from '../Shared/LoadingCircle'
import { examService } from '../../_services/exam.service'
// import "react-circular-progressbar/dist/styles.css"
// import NumberFormat from 'react-number-format'
import examStatuses from '../../_constants/examStatuses'
import { FaPlay } from 'react-icons/fa'
import scrollToComponent from 'react-scroll-to-component'
import { AiOutlineLoading, AiOutlineSave } from 'react-icons/ai'
import moment from 'moment-jalaali'

import { Formik, Field, getIn, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import ErrorPopUp from '../Shared/ErrorPopUp'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import Slide from '@material-ui/core/Slide'
import { CircularProgress, Button, DialogTitle } from '@material-ui/core'
import Fab from '@material-ui/core/Fab'
import { MdClose } from 'react-icons/md'

import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormControl from '@material-ui/core/FormControl'
import FormLabel from '@material-ui/core/FormLabel'

import CountDown from '../Shared/CountDown'

import { config } from '../../config'
import { toastr } from 'react-redux-toastr'
const base_url = config.apiBaseUrl

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />
})

class StartExam extends React.Component {
  constructor(props, context) {
    super(props, context)

    this.state = {
      loading: true,
      data: [],
      questionsCount: 0,
      selected: '',
      key: 0,
      res: {
        examId: this.props.match.params.id,
        memberId: this.props.user.id,
        result: []
      },
      submititng: false,
      resultDialogShow: false
    }
  }

  componentDidMount = () => {
    LoadingBar(true)

    this.getData()
  }

  getData() {
    if (this.props.match.params.id) {
      this.setState(
        { examId: this.props.match.params.id, loading: true },
        () => {
          examService
            .getQuestions(this.state.examId)
            .then(res => {
              // console.log(res.data)
              var data = res.data
              this.setState(
                {
                  data: data,
                  questionsCount: data.questions.length,
                  loading: false
                },
                () => {
                  LoadingBar(false)
                }
              )
            })
            .catch(error => {
              this.handleError(error)
              history.push('/member/exam')
            })
        }
      )
    } else {
      toastr.warning('صفحه مورد نظر وجود ندارد')
      history.push('/member/exam')
    }
  }

  handleError(error) {
    this.setState({ loading: false })
    LoadingBar(false)
    // console.log(error);
  }

  handleStartExam = e => {
    e.preventDefault()

    // this.setState({ examTransferToBankLoading: id })

    // window.location.assign(base_url + 'bank/examTransferToBank/' + id)
  }

  handleRadioChange = (aId, qId, index) => {
    var res = this.state.res
    var result = res.result
    var obj = {}
    obj['questionId'] = qId
    obj['answerId'] = aId
    result[index] = obj
    res['result'] = result

    this.setState({ res: res }, () => {
      // console.log(result.filter(n => n).length);
      // console.log(this.state.data.questions.length);
      // console.log(this.state.res)
      // console.log(JSON.stringify(this.state.res))
    })
  }

  handleSentResult = e => {
    e.preventDefault()

    const { res, data } = this.state

    if (res.result.filter(n => n).length === data.questions.length) {
      this.setState({ submititng: true })

      // console.log(res);

      examService
        .sendResult(JSON.stringify(res))
        .then(res => {
          // console.log(res)
          toastr.info('اطلاعات با موفقیت ارسال شد')
          this.setState({ submititng: false, result: res.data }, () => {
            LoadingBar(false)
            // history.push('/member/exam')
            this.setState({ resultDialogShow: true })
          })
        })
        .catch(error => {
          this.handleError(error)
          this.setState({ submititng: false }, () => {
            LoadingBar(false)
          })
          // history.push('/member/exam')
          toastr.warning('مشکلی پیش آمد', 'لطفا دوباره سعی کنید')
        })
    } else {
      toastr.warning('لطفا به همه سوالات پاسخ دهید')
    }
  }

  render() {
    const {
      data,
      loading,
      res,
      submititng,
      questionsCount,
      result,
      resultDialogShow
    } = this.state
    const arrayObject = Yup.object().shape({
      questionId: Yup.string()
        .trim()
        .nullable()
        .required('سوال'),
      answerId: Yup.string()
        .trim()
        .nullable()
        .required('جواب')
    })
    const ValidationSchema = Yup.object().shape({
      result: Yup.array()
        .of(arrayObject)
        .min(questionsCount, 'لطفا به همه سوالات پاسخ دهید')
        .required('لطفا به همه سوالات پاسخ دهید')
    })
    return data && data.questions ? (
      <div>
        <div className="row">
          <div className="col-md-10 col-md-offset-1">
            <CountDown remainingSeconds={data && data.expireDate} />
          </div>
        </div>

        {data &&
          data.questions &&
          data.questions.map((item, index) => (
            <div className="row" key={'q-' + item.id + '-index-' + index}>
              <div className="col-md-10 col-md-offset-1">
                <fieldset className="fieldset">
                  <legend>{'سوال ' + (index + 1)}</legend>
                  <h4>{item.name}</h4>
                  <RadioGroup
                    row
                    aria-label="position"
                    name={item.id}
                    onChange={e => {
                      let obj = {}
                      obj['questionId'] = item.id
                      obj['answerId'] = e.target.value

                      this.handleRadioChange(e.target.value, item.id, index)
                    }}>
                    {item.answers &&
                      item.answers.map((answer, aIndex) => (
                        <FormControlLabel
                          key={
                            'q-' +
                            item.id +
                            '-a-' +
                            answer.id +
                            'index-' +
                            aIndex
                          }
                          value={answer.id}
                          control={<Radio color="primary" size="medium" />}
                          label={answer.name}
                          labelPlacement="end"
                          className="radio-btn-label"
                        />
                      ))}
                  </RadioGroup>
                </fieldset>
              </div>
            </div>
          ))}
        <br />
        <div className="row">
          <div className="col-md-10 col-md-offset-1">
            <button
              type="submit"
              className="btn btn-success btn-block p-10"
              onClick={e => this.handleSentResult(e)}>
              {submititng ? (
                <React.Fragment>
                  <AiOutlineLoading className="mdi-spin" size="18px" /> در حال
                  ارسال اطلاعات
                </React.Fragment>
              ) : (
                <React.Fragment>ارسال</React.Fragment>
              )}
            </button>
            {/* <ErrorMessage component={ErrorPopUp} name="result" /> */}
          </div>
        </div>

        <Dialog
          className="league-register-single-dialog"
          open={resultDialogShow}
          TransitionComponent={Transition}
          keepMounted
          maxWidth="xs"
          fullWidth={true}
          onClose={() => history.push('/member/exam')}>
          <DialogTitle>
            <Fab
              color="secondary"
              aria-label="refresh"
              size="small"
              onClick={() => history.push('/member/exam')}
              className="modal-close-btn">
              <MdClose size="20px" />
            </Fab>
          </DialogTitle>
          <DialogContent className="p-20" dividers>
            <div className="row">
              <div className="com sm 9">تعداد پاسخ صحیح:</div>
              <div className="col-sm-3" />
            </div>

            <br />

            <div className="row">
              <div className="com sm 9">تعداد پاسخ اشتباه:</div>
              <div className="col-sm-3" />
            </div>

            <br />

            <div className="row">
              <div className="com sm 9">نتیجه آزمون:</div>
              <div className="col-sm-3" />
            </div>
          </DialogContent>
        </Dialog>

        <br />
        <br />
        <br />
      </div>
    ) : (
      <LoadingCircle />
    )
  }
}

function mapStateToProps(state) {
  const { users, authentication } = state
  const { user } = authentication
  return {
    user,
    users
  }
}

const connectedStartExam = connect(mapStateToProps)(StartExam)
export { connectedStartExam as StartExam }
